import React from 'react';
import { motion } from 'framer-motion';

const SECTORS = [
  { cat: 'Municipal', name: 'Water Systems' },
  { cat: 'Industrial', name: 'Critical Facilities' },
  { cat: 'Government', name: 'Secure Sites' },
  { cat: 'Energy', name: 'Power Infrastructure' },
];

// eslint-disable-next-line no-unused-vars
export default function MapHeader({ totalStates, inView }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
      className="mb-12"
    >
      <p className="kicker mb-4">Our work · Nationwide</p>
      <h2
        className="editorial-headline font-bold text-6xl sm:text-7xl lg:text-[6.5rem] xl:text-[7.5rem] text-foreground mb-5 leading-[0.95]"
        data-testid="map-headline"
      >
        Any Location.
        <span className="italic font-bold text-forest"> Same </span>
        Precision.
      </h2>
      <p
        className="text-foreground/80 leading-[1.7] text-base sm:text-lg max-w-3xl mb-8"
        data-testid="map-lead"
      >
        For more than 25 years, we’ve transformed engineering into infrastructure that
        performs with precision, reliability, and lasting value.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        <div className="lg:col-span-7">
          <p className="text-foreground/70 leading-[1.75] text-[15px] sm:text-base max-w-xl" data-testid="map-body">
            With projects spanning municipal water systems, industrial facilities,
            military installations, and energy infrastructure, OMC brings the same
            standard of execution wherever the work takes us.
          </p>
        </div>
        <div className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-x-6 gap-y-6" data-testid="map-sectors">
            {SECTORS.map((s) => (
              <div
                key={s.cat}
                className="border-l-2 border-[hsl(var(--forest)/0.4)] pl-3.5"
                data-testid={`map-sector-${s.cat.toLowerCase()}`}
              >
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[hsl(var(--forest))] mb-1">
                  {s.cat}
                </p>
                <p className="font-display font-semibold text-base lg:text-lg text-foreground leading-tight">
                  {s.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
